module.exports = __webpack_public_path__ + "img/img_baby_admin_2_en.8467fdb5.png";